export default "__VITE_ASSET__ChnW4czl__"